import { render } from "./DatosMedicacion.vue?vue&type=template&id=7a727ad6"
import script from "./DatosMedicacion.vue?vue&type=script&lang=js"
export * from "./DatosMedicacion.vue?vue&type=script&lang=js"

import "./DatosMedicacion.vue?vue&type=style&index=0&id=7a727ad6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__